import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getUserProfileKitsCreated = async ({ uid }) => {
	try {
		const userProfileDocRef = firestore.collection('userProfiles').doc(uid)

		const kitsCreatedQuerySnap = await userProfileDocRef.collection('kitsCreated')
			.orderBy('modifiedTimestamp', 'desc')
			.get()

		const kitsCreated = kitsCreatedQuerySnap.docs.map(d => d.data())
		return kitsCreated
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, error)
	}
}

export default getUserProfileKitsCreated



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfileKitsCreated.js